<script setup>
    import { ref, onBeforeMount, computed } from 'vue';
    import store from '../store';
    import api from '../lib/serverApi';
    import dialogs from '../lib/dialogs';
    import AppMenuItem from './AppMenuItem.vue';

    const mainMenu = ref([]);

    async function fillDashboardMenuList() {
        const result = [];
        const dashTree = await api.getDashboardsTree();
        const fillOneLevel = level => {
            for (const item of level) {
                if (item.isFolder) fillOneLevel(item.children);
                else {
                    result.push({
                        label: item.name,
                        icon: item.icon || 'pi pi-fw pi-id-card',
                        to: '/App/Dashboards/' + item.key
                    });
                }
            }
        }

        fillOneLevel(dashTree);

        // { label: 'Макариха', icon: 'pi pi-fw pi-id-card', to: '/App/Dashboards/Макариха' },

        return result;
    }


    onBeforeMount(async () => {
        const adminMenu = [
            {
                label: 'Администратор',
                items: [
                    { label: 'Пользователи', icon: 'pi pi-fw pi-users', to: '/App/Users' },
                    { label: 'Сущности', icon: 'pi pi-fw pi-tags', to: '/App/Entities' },
                    { label: 'Источники данных', icon: 'pi pi-fw pi-link', },
                    { label: 'Сценарии', icon: 'pi pi-fw pi-code', },
                    { label: 'Значения', icon: 'pi pi-fw pi-arrow-right-arrow-left', to: '/App/EntitieValues' },
                    { label: 'Система', icon: 'pi pi-fw pi-box', to: '/App/System'},
                    {
                        label: 'Визуализация', icon: 'pi pi-fw pi-desktop',
                        items: [
                            { label: 'Дашбоды', icon: 'pi pi-fw pi-id-card', },
                            { label: 'Мнемосхемы', icon: 'pi pi-fw pi-id-card', },
                            { label: 'Отчеты', icon: 'pi pi-fw pi-id-card', },
                        ]
                    },
                ]
            }
        ];

        try {
            const userMenu = [
                {
                    label: 'Дашборды',
                    items: await fillDashboardMenuList()
                },
                {
                    label: 'Мнемосхемы',
                    items: [
                        { label: 'Схема 1', icon: 'pi pi-fw pi-id-card', },
                    ]
                },
                {
                    label: 'Отчеты',
                    items: [
                        { label: 'Отчет1', icon: 'pi pi-fw pi-id-card', },
                    ]
                }

            ]
            if (store.getters.isUserAdmin) mainMenu.value.push(...adminMenu);
            mainMenu.value.push(...userMenu);
        } catch (error) {
            dialogs.showException(error);
        }
    })

    const processing = computed(() => store.getters.getProcessing);

</script>

<template>
    <ul class="layout-menu" :class="{'p-disabled': processing}">
        <template v-for="(item, i) in mainMenu" :key="item">
            <app-menu-item v-if="!item.separator" :item="item" :index="i"></app-menu-item>
            <li v-if="item.separator" class="menu-separator"></li>
        </template>
    </ul>
</template>

<style lang="scss" scoped></style>
